module.exports = __webpack_public_path__ + "img/max-file-edit--xml.759148a0.svg";